import { createSelector } from 'reselect';
import metaSelector from 'Selectors/metaSelector';
import ustate from 'Selectors/ustateSelector';

const userprofileResultSelector = state => state.userprofileview;

export default createSelector(
	[userprofileResultSelector, metaSelector, ustate],
	(userprofile, meta, ustate) => {
		return {
			userprofileview: userprofile,
			meta: meta,
			ustate: ustate.ustate
		};
	}
);




// WEBPACK FOOTER //
// ./src/selectors/userprofileResultSelector.js